import {
  updateObject,
  WHDataService,
  WHEntryDOM,
  IWHTravelEntryDTO,
  WHTravelEntryDOM,
} from '@workheld/workheld-shared-lib';
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectorRef,
  effect,
  signal,
} from '@angular/core';
import { DataModelHelperService } from 'src/app/app-services-helper/data-model-helper.service';
import { Subscription } from 'rxjs';
import { UIService } from 'src/app/app-services/ui.service';
import { WHEnumDataService } from 'src/app/app-services-helper/w-h-enum-helper.service';

@Component({
  selector: 'ng-bee-type1-travel-entry-static-data',
  templateUrl: './type1-travel-entry-static-data.component.html',
  styleUrls: ['./type1-travel-entry-static-data.component.scss'],
  standalone: false,
})
export class Type1TravelEntryStaticDataComponent implements OnInit, OnDestroy {
  // DATA VAR
  @Input() public entryDOM: WHEntryDOM;
  public travelEntryDOM: WHTravelEntryDOM = {
    loading: true,
    loaded: false,
  } as any;

  // MANAGE SUBSCRIPTIONS
  private subscriptions: Subscription[] = [];
  currentLocale: string;
  $ENUMS_OBJECT = signal(null);

  constructor(
    private dataService: WHDataService,
    private dataModelHelperService: DataModelHelperService,
    private changeDetectorRef: ChangeDetectorRef,
    uiService: UIService,
    private whEnumDataService: WHEnumDataService,
  ) {
    effect(() => {
      this.currentLocale = uiService.$currentLocale();
    });
  }

  ngOnInit() {
    this.$ENUMS_OBJECT = this.whEnumDataService.$ENUMS_OBJECT;

    this.subscriptions.push(
      this.dataService
        .getByUrl(this.entryDOM.entryDetailURL)
        .subscribe((travelEntryDTO: IWHTravelEntryDTO) => {
          if (!travelEntryDTO) {
            this.travelEntryDOM = updateObject(this.travelEntryDOM, {
              loading: false,
              loaded: false,
            } as any);
            this.changeDetectorRef.detectChanges();
            return;
          }
          this.travelEntryDOM = updateObject(
            this.travelEntryDOM,
            this.dataModelHelperService.initTravelEntryDOM(travelEntryDTO),
          );
          this.changeDetectorRef.detectChanges();
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
  }
}
